async function request<T>(
    url: string,
    method: 'GET' | 'POST' = 'GET',
    body: object | null = null,
    params: Record<string, string> = {}
): Promise<T> {
    // Convert params object to a search string
    const searchParams = new URLSearchParams(params).toString();

    // Append search params to the URL for GET requests
    if (method === 'GET' && searchParams) {
        url += `?${searchParams}`;
    }

    const options: RequestInit = {
        method,
        headers: {
            'Content-Type': 'application/json',
        },
    };

    // Add body to the options for POST requests
    if (method === 'POST' && body) {
        options.body = JSON.stringify(body);
    }

    const response = await fetch(url, options);

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
}

const get = <T>(url: string, params?: Record<string, string>) =>
    request<T>(url, 'GET', null, params);
const post = (url: string, body: object, params?: Record<string, string>) =>
    request(url, 'POST', body, params);

export { get, post };
